import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]

  connect() {
    this.currentIndex = 0
    this.showStep(0)
    this.timer = setInterval(() => this.advance(), 3000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  advance() {
    this.currentIndex = (this.currentIndex + 1) % this.stepTargets.length
    this.showStep(this.currentIndex)
  }

  showStep(index) {
    this.stepTargets.forEach((step, i) => {
      if (i === index) {
        step.classList.remove("opacity-0")
        step.classList.add("opacity-100")
      } else {
        step.classList.remove("opacity-100")
        step.classList.add("opacity-0")
      }
    })
  }
}
